import React from "react";

// Style
import "./PharmacopoeiaItems.scss";

// Constants
import { pharmacopoeiaDescriptions } from "constans/pharmacopoeia";

// Classnames
import clsx from "clsx";

// Interface
interface PharmacopoeiaItemsProps {
  data: string[];
  isComma?: boolean;
  className?: string;
}

export const PharmacopoeiaItems: React.FC<PharmacopoeiaItemsProps> = (props) => {
  const {
    data = [],
    className = "",
    isComma = false
  } = props;

  const cnSpan = clsx(
    "pharmacopoeia-items",
    className ? className : ""
  );

  return (
    <>
      {!!data?.length ? data?.map((item, index) => {
        const description = pharmacopoeiaDescriptions[item] || "No description available";
        return (
          <span
            key={index}
            className={cnSpan}
            title={description}
          >
            {item}
            {isComma && index < data.length - 1 && ",\u00A0"}
          </span>
        );
      }) : null}
    </>
  );
};

export default PharmacopoeiaItems;